module.exports = __webpack_public_path__ + "logo.e41ba5b8fa6d53f9d86dc178d0e854d3.png";